import { styled } from '@mui/material/styles';

import { Box } from '../../atoms/Box';
import { Typography } from '../../atoms/Typography';

export const ContentWrapperBox = styled(Box)`
  position: relative;
  width: 100%;
`;

export const HeadingWrapper = styled(Typography)`
  padding-bottom: 20px;
`;

export const SelectionWrapper = styled(Box)`
  width: 100%;
`;

export const SelectBox = styled(Box)`
  padding-right: 15px;
  width: 100%;
`;